import { createSlice } from '@reduxjs/toolkit';

import { COUNTRIES } from '@app/store';
import { WORK_SCHEDULE_SERVICE_INITIAL_STATE } from '@app/store/reducers/workScheduleServiceReducer/workScheduleService.state';

import type { PayloadAction } from '@reduxjs/toolkit';

const workScheduleServiceSlice = createSlice({
  name: COUNTRIES,
  initialState: WORK_SCHEDULE_SERVICE_INITIAL_STATE,
  reducers: {
    setPage: (state, { payload }: PayloadAction<{ page: number }>) => {
      const { page } = payload;

      state.page = page;
    },
  },
});

export const { setPage } = workScheduleServiceSlice.actions;
export const workScheduleServiceReducer = workScheduleServiceSlice.reducer;
